import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect, useState, lazy, Suspense } from 'react';
import axios from 'axios';
// Eager-loaded: zichtbaar bij first paint of essentieel voor opstart
import Login from './pages/Login';
import ComingSoon from './pages/ComingSoon';
import Maintenance from './pages/Maintenance';
import ProtectedRoute from './components/ProtectedRoute';
// Lazy-loaded: pas gefetched bij eerste navigatie naar die route
const Landing = lazy(() => import('./pages/Landing'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Voorwaarden = lazy(() => import('./pages/Voorwaarden'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Admin = lazy(() => import('./pages/Admin'));

function PageLoader() {
  return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Laden…</div>;
}

function Layout() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<ComingSoon />} />
        <Route path="/binnenkort" element={<ComingSoon />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/preview" element={<Landing />} />
        <Route path="/over-ons" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/voorwaarden" element={<Voorwaarden />} />
        <Route path="/login" element={<Login />} />
        <Route path="/wachtwoord-vergeten" element={<ForgotPassword />} />
        <Route path="/wachtwoord-herstellen" element={<ResetPassword />} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  const [maintenance, setMaintenance] = useState(false);
  const [checked, setChecked] = useState(false);

  // Globale 401-interceptor: zodra een API-call met "Unauthorized" terug komt
  // (token verlopen / ingetrokken / user verwijderd) wordt de localStorage
  // geleegd en de gebruiker terug naar /login gestuurd.
  useEffect(() => {
    const id = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          const hasToken = localStorage.getItem('token');
          if (hasToken) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            if (window.location.pathname !== '/login') {
              window.location.href = '/login';
            }
          }
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(id);
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/admin/maintenance`)
      .then(res => {
        setMaintenance(res.data.maintenance);
        setChecked(true);
      })
      .catch(() => setChecked(true));
  }, []);

  if (!checked) return null;

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user?.role === 'admin';

  if (maintenance && !isAdmin) {
    const path = window.location.pathname;
    if (path !== '/login' && path !== '/admin') {
      return <Maintenance />;
    }
  }

  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
